import axios from 'axios';

const register = async (body) => {
    // REQUEST FOR REGISTER TOKEN
    const data = await axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}Register_MiniApp`,
        data: { ...body },
    });
    // IF NO ERROR, REGISTER USER
    if (!data.error) return data;

    // RESOLVE ERROR
    else new Promise((resolve) => resolve({ response: "Something went wrong", statusCode: 500 }));
}

const auth = async (body) => {
    // REQUEST FOR REGISTER TOKEN
    const { data } = await token("Login");

    // IF NO ERROR, REGISTER USER
    if (!data.error) return axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_COINCAEX_AJAX}loginUser`,
        data: { ...body, __token: data.passKey, kitQR: true },
    });

    // RESOLVE ERROR
    else new Promise((resolve) => resolve({ response: "Something went wrong", statusCode: 500 }));
}

const update = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}updateUserFromSubsum`,
    data: body,
});

const contract = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}GuardarContratoKitQR`,
    data: body,
});

const sign = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}SignContractKitQR`,
    data: body,
});

const kycToken = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}getTokenSumsubKitQr`,
    data: body,
});

const kycStatus = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}getKYCStatusKitQr`,
    data: body,
});

const checkEmail = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}GetCollectionKitQR`,
    data: body,
});

const sendEmail = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}Send_Otp_Email`,
    data: body,
});

const verifyEmailOtp = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}Validate_Otp_Email`,
    data: body,
});

const confirmBitpos = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}BitposFormPrebuild`,
    data: body,
});

const getContract = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}ObtenerContrato`,
    data: body,
});

const updatePhone = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}updateUserPhone`,
    data: body,
});

const handleMinikit = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}handleMinikit`,
    data: body
});

const checkPoint = async (body) => axios ({
    method: 'GET',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}getActivationCenters`,
})

const getKioskos = async () => axios ({
    method: 'GET',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}getKioskosEfectivo`,
})

const miniappUser = async (body) => axios ({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}miniappUserByEmail`,
    data: body
})

const getIp = async (body) => axios ({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=GetUserRequestInfo`,
    data: body
})

// ENDPOINT HANDLING FOR DISCOUNT CODES
const controllerDiscountCode = async (body) => axios ({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}controllerHandleExternalReferralCode`,
    data: body
})

const getDiscountCode = async (body) => axios ({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}GetUserDiscountCode`,
    data: body
})

// ENDPOINT HANDLING FOR AWARDS USER
const controllerAwards = async (body) => axios ({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}controllerAwardsUser`,
    data: body
})

const getMapInfo = async (body) => axios ({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}getMapInfo`,
    data: body
})

export { register, auth, kycToken, kycStatus, update, contract, sign, checkEmail, sendEmail, verifyEmailOtp, confirmBitpos, getContract, updatePhone, getIp, 
        handleMinikit, checkPoint, getKioskos, controllerDiscountCode, getDiscountCode, controllerAwards, miniappUser, getMapInfo }
